import React from "react";
import InfoIcon from "../svgs/infoIcon";
import "./gettingStartedButtons.css";
import Fab from "../fab/fab";

const GettingStartedButton = (props) => {
  const { handleClick } = props;
  return (
    <Fab weight={1} onClick={handleClick} className="getting-started-button">
      <div className="getting-started-button-inner">
        <InfoIcon />
        <p>Quick Start</p>
      </div>
    </Fab>
  );
};

export default GettingStartedButton;
